import script from "./nongye1.vue?vue&type=script&setup=true&lang=js"
export * from "./nongye1.vue?vue&type=script&setup=true&lang=js"

import "./nongye1.vue?vue&type=style&index=0&id=5672f708&lang=less&scoped=true"
script.__scopeId = "data-v-5672f708"

export default script